export class ServicingListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            servicing: lang.service[18],
            description: lang.service[1],
            type: lang.service[0],
            matricolaNumberPlate: lang.service[5],
            factoryNumber: lang.service[6],
            brand: lang.service[3],
            model: lang.service[4],
            dateofCommissioning: lang.service[7],
            location: lang.service[8],
            responsible: lang.service[10],
            maintenancePlans: lang.service[121],
            status: lang.service[21],
            photo: lang.service[2],
            action: lang.service[22],
            view: lang.service[48],
            vehicle: lang.service[77],
            plant: lang.service[78],
            machine: lang.service[79],
            fireDispenser: lang.service[80],
            firstServiceDevice: lang.service[81],
            individualProtectionDevice: lang.service[82],
            safetyEquipment: lang.service[83],
            active: lang.service[15],
            decommissioned: lang.service[46],
            locations: lang.locations,
            responsibles: lang.responsibles,
            erase: lang.general[4],
            duplicate: lang.general[8],
            modify: lang.general[2],
            planCode: lang.service[123],
            repetitions: lang.service[104],
            daysnotify: lang.service[93],
            notification_time: lang.service[95],
            equipment_to_which_the_plan_applies: lang.service[124],
            sno: lang.service[114],
            notification_days: lang.service[94],
            selectAll: lang.general[10],
            selectColumns: lang.general[9],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            close: lang.general[17],
            maintenanceStatus: lang.service[156],
            attachments: lang.service[9],
            dateofcommissioning: lang.service[7],
            submit:lang.general[36],
            applicableMaintenanceplans:lang.service[157],
            planDescription:lang.service[144],
            executionDate:lang.service[35],
            daysleft:lang.service[86],
            listofequipment:lang.service[120],
            requiredField: lang.service[64],
            createMaintenanceplan: lang.service[125],
            modifyMaintenanceplan: lang.service[127],
            save: lang.general[0],
            createServicing: lang.service[165],
            select: lang.general[67],
            selectEmployee: lang.service[84],
            editServicingplan: lang.service[113],
            list: lang.service[130],
            maintenancePlanning: lang.service[122],
            plancodealreadyexists: lang.service[166],
            daysnotifys: lang.service[167],
            correctemail: lang.service[168],
            pleaseenteronlydigits: lang.service[169],
            areyousuretodelete: lang.service[137],
            maintenancedeleteconfirm: lang.service[170],
            withoutsaving: lang.service[138],
            copyallSelected: lang.service[139],
            dataImport: lang.service[47],
            downloadCsv: lang.service[45],
            activeorder: lang.service[129],
            duplicateAll: lang.general[74],
            duplicateoption: lang.general[82],
            duplicateConfirm: lang.general[79],
            multiduplicateConfirm: lang.general[78],
            deleteAll: lang.general[75],
            servicingDelete: lang.general[84],
            servdeletetext: lang.general[85],
            muldelete: lang.general[83],
            select_type: lang.general[31],
            select_status: lang.general[97],
            select_location: lang.general[104],
            select_responsible: lang.general[105],
            gen_active: lang.general[106],
            expired: lang.general[107],


        }

    }

    lang() {
        return this.variables;
    }

}

export class ServicingCreateLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            supportservice: lang.service[0],
            createservice: lang.service[16],
            category: lang.service[21],
            description: lang.service[1],
            vehicle: lang.service[77],
            plant: lang.service[78],
            machine: lang.service[79],
            fireDispenser: lang.service[80],
            firstServiceDevice: lang.service[81],
            individualProtectionDevice: lang.service[82],
            safetyEquipment: lang.service[83],
            type: lang.service[0],
            matricolaNumberPlate: lang.service[5],
            factoryNumber: lang.service[6],
            brand: lang.service[3],
            model: lang.service[4],
            dateofCommissioning: lang.service[7],
            location: lang.service[8],
            responsible: lang.service[10],
            maintenancePlans: lang.service[121],
            status: lang.service[21],
            photo: lang.service[2],
            planCode: lang.service[123],
            howoftentorepeat: lang.service[126],
            daysnotify: lang.service[93],
            notificationtime: lang.service[95],
            equipment_to_which_the_plan_applies: lang.service[124],
            reference_email: lang.service[88],
            submit: lang.general[37],
            close: lang.general[17],
            save: lang.general[0],
            requiredField: lang.service[64],
            selectType: lang.general[31],
            select: lang.general[67],
            selectTime: lang.general[32],

        }

    }

    lang() {
        return this.variables;
    }

}

export class ServicingViewLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            supportservice: lang.service[0],
            viewservice: lang.service[8],
            serviceNo: lang.service[1],
            category: lang.service[2],
            created: lang.service[3],
            open: lang.service[6],
            closed: lang.service[7],
            sendReply: 'Send Reply'
        }

    }

    lang() {
        return this.variables;
    }

}


export class SettingsListLangForm {

    variables  = null;

    constructor(lang) {

        this.variables = {
            view: lang.general[3],
            modify: lang.general[2],
            reload: 'Reload',
            section: lang.settings[34],
            title: lang.settings[35],
            actions: lang.settings[32],
            requiredField: lang.service[64],
        }

    }

    lang() {
        return this.variables;
    }

}

export class SettingsEditLangForm {

    variables  = null;

    constructor(lang) {

        this.variables = {
            edit_doc: 'Edit Document',
            section: lang.settings[34],
            title: lang.settings[35],
            orient: lang.settings[37],
            horizontal: lang.settings[38],
            vertical: lang.settings[39],
            back_image: lang.settings[40],
            choose_file: 'Choose File',
            template: lang.settings[41],
            default_var: lang.settings[42],
            submit: lang.general[0],
            close: lang.general[17],
        }

    }

    lang() {
        return this.variables;
    }

}

export class SettingsSettingsLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            language: lang.settings[43],
            timezone: lang.settings[45],
            edit: 'Edit',
            update: 'Update',
        }

    }

    lang() {
        return this.variables;
    }

}

export class ServicingUserLang {

    public static general = {
        requiredField: 26,
        edit: 'Edit',
        update: 'Update',
        selectFile: 'Select File',
        modify: 2,
        delete: 4,
        submit: 37,
        close: 17,
        selCol: 9,
        selectAll: 10,
        activeCol: 11,
        exportCsv: 13,
        exportPdf: 14,
        exportExc: 15,
        print: 16,
        confirmTitle: 'User Confirmation',
        confirmText: 36,
        ok: 'OK',
        cancel: 'Cancel',
    }

    public static user = {
        heading: 2,
        sNo: 'S.No',
        profile: 0,
        email: 15,
        firstName: 6,
        lastName: 7,
        actions: 32,
        addUser: 13,
        password: 8,
        profileImage: 9,
        sections: 16,
        readOnly: 17,
        readWrite: 18,
        deny: 19,
        deadlines: 20,
        servicing: 21,
        humanRes: 22,
        measTools: 23,
        probSolv: 24,
        docMang: 25,
        customers: 26,
        consultancy: 27,
        academy: 28,
        project: 29,
        audit: 30,
    }


    
}


export class ServicingCalendarLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            description: lang.servicing[1],
            type: lang.servicing[0],
            month: lang.servicing[102],
            week: lang.servicing[101],
            day: lang.servicing[100],
            brand: lang.servicing[3],
            model: lang.servicing[4],
            matricolaNumber: lang.servicing[5],
            factoryNumber: lang.servicing[6],
            referringPlancode: lang.servicing[143],
            planDescription: lang.servicing[144],
        }

    }

    lang() {
        return this.variables;
    }

}

export class ServicingGeneralLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            description: lang.servicing[1],
            type: lang.servicing[0],
            month: lang.servicing[102],
            week: lang.servicing[101],
            day: lang.servicing[100],
            brand: lang.servicing[3],
            model: lang.servicing[4],
            matricolaNumber: lang.servicing[5],
            factoryNumber: lang.servicing[6],
            referringPlancode: lang.servicing[143],
            planDescription: lang.servicing[144],
        }

    }

    lang() {
        return this.variables;
    }

}


export class ServicingMaintenancePlanningLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            servicing: lang.service[18],
            description: lang.service[1],
            type: lang.service[0],
            matricolaNumberPlate: lang.service[5],
            factoryNumber: lang.service[6],
            brand: lang.service[3],
            model: lang.service[4],
            dateofCommissioning: lang.service[7],
            location: lang.service[8],
            responsible: lang.service[10],
            maintenancePlans: lang.service[121],
            status: lang.service[21],
            photo: lang.service[2],
            action: lang.service[22],
            view: lang.service[48],
            vehicle: lang.service[77],
            plant: lang.service[78],
            machine: lang.service[79],
            fireDispenser: lang.service[80],
            firstServiceDevice: lang.service[81],
            individualProtectionDevice: lang.service[82],
            safetyEquipment: lang.service[83],
            active: lang.service[15],
            decommissioned: lang.service[46],
            locations: lang.locations,
            responsibles: lang.responsibles,
            erase: lang.general[4],
            duplicate: lang.general[8],
            modify: lang.general[2],
            planCode: lang.service[123],
            repetitions: lang.service[104],
            daysnotify: lang.service[93],
            notification_time: lang.service[95],
            equipment_to_which_the_plan_applies: lang.service[124],
            sno: lang.service[114],
            notification_days: lang.service[94],
            selectAll: lang.general[10],
            selectColumns: lang.general[9],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            close: lang.general[17],
            maintenanceStatus: lang.service[156],
            attachments: lang.service[9],
            dateofcommissioning: lang.service[7],
            submit:lang.general[36],
            applicableMaintenanceplans:lang.service[157],
            equipmentDescription:lang.service[142],
            referringPlancode:lang.service[143],
            executionDate: lang.service[35],
            daysleft:lang.service[86],
            planDescription:lang.service[144],
            insertMaintenance:lang.service[145],
            activeColumns:lang.general[11],
            listofequipment:lang.service[120],
            generalData:lang.service[49],
        }

    }

    lang() {
        return this.variables;
    }

}

export class ServicingViewGeneralLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            servicing: lang.service[18],
            generalData:lang.service[49],            
            ordinaryData: lang.service[50],
            extraordinaryData: lang.service[51],
            type: lang.service[0],
            description: lang.service[1],
            brand: lang.service[3],
            model: lang.service[4],
            factoryNumber: lang.service[6],
            matricolaNumberPlate: lang.service[5],
            dateofCommissioning: lang.service[7],
            location: lang.service[8],
            responsible: lang.service[10],
            maintenancePlans: lang.service[121],
            status: lang.service[21],
            attachments: lang.service[9],
            photo: lang.service[2],
            action: lang.service[22],
            view: lang.service[48],
            vehicle: lang.service[77],
            plant: lang.service[78],
            machine: lang.service[79],
            fireDispenser: lang.service[80],
            firstServiceDevice: lang.service[81],
            individualProtectionDevice: lang.service[82],
            safetyEquipment: lang.service[83],
            active: lang.service[15],
            decommissioned: lang.service[46],
            locations: lang.locations,
            responsibles: lang.responsibles,
            erase: lang.general[4],
            duplicate: lang.general[8],
            modify: lang.general[2],
            planCode: lang.service[123],
            repetitions: lang.service[104],
            daysnotify: lang.service[93],
            notification_time: lang.service[95],
            equipment_to_which_the_plan_applies: lang.service[124],
            sno: lang.service[114],
            notification_days: lang.service[94],
            selectAll: lang.general[10],
            selectColumns: lang.general[9],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            close: lang.general[17],
            maintenanceStatus: lang.service[156],
            dateofcommissioning: lang.service[7],
            submit:lang.general[37],
            applicableMaintenanceplans:lang.service[157],
            equipmentDescription:lang.service[142],
            referringPlancode:lang.service[143],
            executionDate: lang.service[35],
            daysleft:lang.service[86],
            planDescription:lang.service[144],
            insertMaintenance:lang.service[145],
            activeColumns:lang.general[11],
            listofequipment:lang.service[120],
            planStartingdate:lang.service[146],
            activatePlan:lang.service[147],
            deactivatePlan:lang.service[148],
            enterStartdate:lang.service[150],
            performer: lang.service[36],
            editServicingplan: lang.service[113],
            save: lang.general[0],
            search: lang.general[33],
            documents: lang.service[160],
            statistics: lang.service[172],
            ordinary_maintance_costs: lang.service[175],
            exordinary_maintance_costs: lang.service[176],
            plan_desc: lang.service[144],




        }

    }

    lang() {
        return this.variables;
    }

}

export class ServicingMaintenanceLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            performer:lang.service[36],
            executionDate: lang.service[35],
            description: lang.service[1],
            outcome: lang.service[37],
            positive: lang.service[60],
            negative: lang.service[61],
            note: lang.service[58],
            cost: lang.service[42],
            nextDeadline: lang.service[97],
            change: lang.service[14],
            attachments: lang.service[9],
            submit:lang.general[37],
            close: lang.general[17],
            referringDate: lang.service[40],
            donotaffect: lang.service[99],
        }

    }

    lang() {
        return this.variables;
    }

}


export class ServicingOrdinaryLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            servicing: lang.service[18],
            generalData:lang.service[49],            
            ordinaryData: lang.service[50],
            extraordinaryData: lang.service[51],
            type: lang.service[0],
            description: lang.service[1],
            brand: lang.service[3],
            model: lang.service[4],
            factoryNumber: lang.service[6],
            matricolaNumberPlate: lang.service[5],
            dateofCommissioning: lang.service[7],
            location: lang.service[8],
            responsible: lang.service[10],
            maintenancePlans: lang.service[121],
            status: lang.service[21],
            attachments: lang.service[9],
            photo: lang.service[2],
            action: lang.service[22],
            view: lang.service[48],
            vehicle: lang.service[77],
            plant: lang.service[78],
            machine: lang.service[79],
            fireDispenser: lang.service[80],
            firstServiceDevice: lang.service[81],
            individualProtectionDevice: lang.service[82],
            safetyEquipment: lang.service[83],
            active: lang.service[15],
            decommissioned: lang.service[46],
            locations: lang.locations,
            responsibles: lang.responsibles,
            erase: lang.general[4],
            duplicate: lang.general[8],
            modify: lang.general[2],
            planCode: lang.service[123],
            repetitions: lang.service[104],
            daysnotify: lang.service[93],
            notification_time: lang.service[95],
            equipment_to_which_the_plan_applies: lang.service[124],
            sno: lang.service[114],
            notification_days: lang.service[94],
            selectAll: lang.general[10],
            selectColumns: lang.general[9],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            close: lang.general[17],
            maintenanceStatus: lang.service[156],
            dateofcommissioning: lang.service[7],
            submit:lang.general[37],
            applicableMaintenanceplans:lang.service[157],
            equipmentDescription:lang.service[142],
            referringPlancode:lang.service[143],
            executionDate: lang.service[35],
            daysleft:lang.service[86],
            planDescription:lang.service[144],
            insertMaintenance:lang.service[145],
            activeColumns:lang.general[11],
            listofequipment:lang.service[120],
            planStartingdate:lang.service[146],
            activatePlan:lang.service[147],
            deactivatePlan:lang.service[148],
            enterStartdate:lang.service[150],
            performer:lang.service[36],
            insertOrdinaryMaintenance:lang.service[153],
            notes: lang.service[38],
            nextintervention: lang.service[39],
            cost: lang.service[42],
            nextDeadline: lang.service[97],
            change: lang.service[14],
            option: lang.service[154],
            referringDate: lang.service[40],
            outcome: lang.service[37],
            donotaffect: lang.service[99],
            positive: lang.service[60],
            negative: lang.service[61],
            save: lang.general[0],
            newIntervention: lang.service[91],
            modifyIntervention: lang.service[23],

        }

    }

    lang() {
        return this.variables;
    }

}

export class ServicingExOrdinaryLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            servicing: lang.service[18],
            generalData:lang.service[49],            
            ordinaryData: lang.service[50],
            extraordinaryData: lang.service[51],
            type: lang.service[0],
            description: lang.service[1],
            brand: lang.service[3],
            model: lang.service[4],
            factoryNumber: lang.service[6],
            matricolaNumberPlate: lang.service[5],
            dateofCommissioning: lang.service[7],
            location: lang.service[8],
            responsible: lang.service[10],
            maintenancePlans: lang.service[121],
            status: lang.service[21],
            attachments: lang.service[9],
            photo: lang.service[2],
            action: lang.service[22],
            view: lang.service[48],
            vehicle: lang.service[77],
            plant: lang.service[78],
            machine: lang.service[79],
            fireDispenser: lang.service[80],
            firstServiceDevice: lang.service[81],
            individualProtectionDevice: lang.service[82],
            safetyEquipment: lang.service[83],
            active: lang.service[15],
            decommissioned: lang.service[46],
            locations: lang.locations,
            responsibles: lang.responsibles,
            erase: lang.general[4],
            duplicate: lang.general[8],
            modify: lang.general[2],
            planCode: lang.service[123],
            repetitions: lang.service[104],
            daysnotify: lang.service[93],
            notification_time: lang.service[95],
            equipment_to_which_the_plan_applies: lang.service[124],
            sno: lang.service[114],
            notification_days: lang.service[94],
            selectAll: lang.general[10],
            selectColumns: lang.general[9],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            close: lang.general[17],
            maintenanceStatus: lang.service[156],
            dateofcommissioning: lang.service[7],
            submit:lang.general[37],
            applicableMaintenanceplans:lang.service[157],
            equipmentDescription:lang.service[142],
            referringPlancode:lang.service[143],
            executionDate: lang.service[35],
            daysleft:lang.service[86],
            planDescription:lang.service[144],
            insertMaintenance:lang.service[145],
            activeColumns:lang.general[11],
            listofequipment:lang.service[120],
            planStartingdate:lang.service[146],
            activatePlan:lang.service[147],
            deactivatePlan:lang.service[148],
            enterStartdate:lang.service[150],
            performer:lang.service[36],
            insertOrdinaryMaintenance:lang.service[153],
            notes: lang.service[38],
            nextintervention: lang.service[39],
            cost: lang.service[42],
            nextDeadline: lang.service[97],
            change: lang.service[14],
            option: lang.service[154],
            referringDate: lang.service[40],
            outcome: lang.service[37],
            donotaffect: lang.service[99],
            positive: lang.service[60],
            negative: lang.service[61],
            save: lang.general[0],
            newIntervention: lang.service[91],
            modifyIntervention: lang.service[23],
            dateofIntervention: lang.service[57],
            enter: lang.service[59],
            extraordinaryMaintenance: lang.service[51],
            links: lang.service[173],

        }

    }

   

    lang() {
        return this.variables;
    }


   

}


export class ServicingDocumentsLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            sno: lang.service[114],
            description: lang.service[1],
            attachments: lang.service[9],
            action: lang.service[22],
            status: lang.service[21],
            erase: lang.general[4],
            duplicate: lang.general[8],
            modify: lang.general[2],
            date: lang.service[158],
            revision: lang.service[159],
            documents: lang.service[160],
            createDocument: lang.service[161],
            modifyDocument: lang.service[162],
            valid: lang.service[163],
            passed: lang.service[164],
            selectAll: lang.general[10],
            selectColumns: lang.general[9],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            close: lang.general[17],
            dataImport: lang.service[47],
            downloadthecsvtemplate: lang.service[45],
            submit: lang.general[36],
            save: lang.general[0],
            activeColumns:lang.general[11],


        }

    }

    lang() {
        return this.variables;
    }

}